// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-modal {
    width: 90%;
    max-width: 1100px !important;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0 !important;
}

/* Fix for header scrolling */
.company-modal .modal-header {
    position: sticky;
    top: 0;
    background: white;
    z-index: 1100;
    padding: 20px;
    border-bottom: 1px solid #e2e8f0;
    flex-shrink: 0;
}

/* Scrollable content area */
.company-modal form {
    overflow-y: auto;
    padding: 20px;
    flex: 1 1;
}

.form-section {
    margin-bottom: 25px;
    padding: 15px;
    background-color: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
}

.form-section h3 {
    margin-top: 0;
    margin-bottom: 15px;
    color: #2d3748;
    border-bottom: 2px solid #e2e8f0;
    padding-bottom: 8px;
}

.form-section h4 {
    margin-top: 0;
    color: #4a5568;
    font-size: 0.95rem;
    margin-bottom: 10px;
}

.form-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    margin-bottom: 15px;
}

.form-row-3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    margin-bottom: 15px;
}

.form-col {
    flex: 1 1;
    background: white;
    padding: 15px;
    border-radius: 6px;
    border: 1px solid #edf2f7;
}

.btn-company-settings {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #718096;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-company-settings:hover {
    background-color: #4a5568;
}

.password-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
}

.password-wrapper {
    position: relative;
    width: 100%;
}

.password-wrapper input {
    padding-right: 40px !important;
    height: 42px !important;
    box-sizing: border-box !important;
    line-height: 42px !important;
}

.password-toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #a0aec0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    height: 24px;
    width: 24px;
    overflow: hidden;
    line-height: 0;
    transition: color 0.2s;
    z-index: 5;
}

.password-toggle:hover {
    color: #4a5568;
}

.password-wrapper input::-ms-reveal,
.password-wrapper input::-ms-clear {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/CompanySettingsModal.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,6BAA6B;AAC7B;IACI,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,gCAAgC;IAChC,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,aAAa;IACb,SAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB","sourcesContent":[".company-modal {\r\n    width: 90%;\r\n    max-width: 1100px !important;\r\n    max-height: 90vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    padding: 0 !important;\r\n}\r\n\r\n/* Fix for header scrolling */\r\n.company-modal .modal-header {\r\n    position: sticky;\r\n    top: 0;\r\n    background: white;\r\n    z-index: 1100;\r\n    padding: 20px;\r\n    border-bottom: 1px solid #e2e8f0;\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* Scrollable content area */\r\n.company-modal form {\r\n    overflow-y: auto;\r\n    padding: 20px;\r\n    flex: 1;\r\n}\r\n\r\n.form-section {\r\n    margin-bottom: 25px;\r\n    padding: 15px;\r\n    background-color: #f8fafc;\r\n    border-radius: 8px;\r\n    border: 1px solid #e2e8f0;\r\n}\r\n\r\n.form-section h3 {\r\n    margin-top: 0;\r\n    margin-bottom: 15px;\r\n    color: #2d3748;\r\n    border-bottom: 2px solid #e2e8f0;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n.form-section h4 {\r\n    margin-top: 0;\r\n    color: #4a5568;\r\n    font-size: 0.95rem;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.form-row {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 15px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.form-row-3 {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 15px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.form-col {\r\n    flex: 1;\r\n    background: white;\r\n    padding: 15px;\r\n    border-radius: 6px;\r\n    border: 1px solid #edf2f7;\r\n}\r\n\r\n.btn-company-settings {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    background-color: #718096;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 16px;\r\n    border-radius: 6px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: all 0.2s;\r\n}\r\n\r\n.btn-company-settings:hover {\r\n    background-color: #4a5568;\r\n}\r\n\r\n.password-wrapper {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n\r\n.password-wrapper {\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n.password-wrapper input {\r\n    padding-right: 40px !important;\r\n    height: 42px !important;\r\n    box-sizing: border-box !important;\r\n    line-height: 42px !important;\r\n}\r\n\r\n.password-toggle {\r\n    position: absolute;\r\n    right: 10px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: #a0aec0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0;\r\n    height: 24px;\r\n    width: 24px;\r\n    overflow: hidden;\r\n    line-height: 0;\r\n    transition: color 0.2s;\r\n    z-index: 5;\r\n}\r\n\r\n.password-toggle:hover {\r\n    color: #4a5568;\r\n}\r\n\r\n.password-wrapper input::-ms-reveal,\r\n.password-wrapper input::-ms-clear {\r\n    display: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
